import { bl_applet_template_message_hdr_RowClass } from '../../dbschema/bl_applet_template_message_hdr.model';
import { bl_applet_template_message_line_RowClass } from "../../dbschema/bl_applet_template_message_line.model";
import { BaseContainerModel } from '../base-container.model';

export class AppletTemplateMessageContainer extends BaseContainerModel {
    bl_applet_template_message_hdr: bl_applet_template_message_hdr_RowClass = new bl_applet_template_message_hdr_RowClass();
    bl_applet_template_message_lines: bl_applet_template_message_line_RowClass[] = [];
}